export const pathWithGeneralLayout = ["/", "/terms", "/policy"];
